import Scene from "~/scene";
import SceneMarkerMapyWindyPlace from "~/scene/marker/mapy-windy-place";

export function createGeometryCardMarker(item, id: string, cardClick: (item?: any) => void = () => {}): SceneMarkerMapyWindyPlace {
	const marker = Scene.createMarkerMapyWindyPlace(null, item, {
		type: Scene.VISUAL.MARKER_WINDY.LITTLE,
		cardClick,
	}, `${id}-card-${Date.now()}`);

	marker.setCardOptions({
		showTimeout: 0,
		hideTimeout: 0,
	});

	marker.setNonInteractive(true);

	return marker;
}
